import { LegalLayout } from "@/components/LegalLayout";

const sections = [
  {
    h: "1. Agreement to these terms",
    p: [
      "These Terms & Conditions (\u201cTerms\u201d) govern your access to and use of the Swishr Central website and application (the \u201cService\u201d). By creating an account or using the Service, you agree to these Terms. If you do not agree, do not use the Service.",
      "The Service is provided by Swishr Digital Ltd, a company registered in England and Wales under company number 17391541, with its registered office at Flat 6 Logan House, 1 Logan Place, London, United Kingdom, W8 6QN (\u201cwe\u201d, \u201cus\u201d, \u201cour\u201d).",
    ],
  },
  {
    h: "2. The Service and your licence",
    p: [
      "Subject to these Terms and your payment of any applicable fees, we grant you a non-exclusive, non-transferable right to access and use the Service for your internal business or personal-assistant purposes during your subscription.",
    ],
  },
  {
    h: "3. Accounts and security",
    p: [
      "You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account. You must give accurate account information and keep it up to date, and tell us promptly of any unauthorised use. You must be at least 18 years old to use the Service.",
    ],
  },
  {
    h: "4. Acceptable use",
    p: ["You agree not to:"],
    list: [
      "Use the Service unlawfully or in breach of any applicable regulation.",
      "Upload content you have no right to use, or that is unlawful, infringing or harmful.",
      "Attempt to gain unauthorised access to the Service, other workspaces, or our systems.",
      "Interfere with or disrupt the integrity or performance of the Service.",
      "Reverse engineer, resell or sub-license the Service except as permitted by law.",
    ],
  },
  {
    h: "5. Your content and data",
    p: [
      "You retain all rights in the content and data you add to your workspace (\u201cYour Content\u201d). You grant us the limited rights needed to host, process and display Your Content solely to provide the Service to you.",
      "You are responsible for Your Content and for having a lawful basis to process any personal data about third parties (such as principals and contacts) that you enter into the Service. Our handling of personal data is described in our Privacy Policy.",
    ],
  },
  {
    h: "6. AI features",
    p: [
      "The Service includes AI-assisted features that generate suggestions, summaries and transcriptions. These outputs may be inaccurate or incomplete and are provided for your review. You remain responsible for checking and deciding whether to rely on any AI output, and you should not treat it as professional advice.",
    ],
  },
  {
    h: "7. Subscriptions, fees and trials",
    p: [
      "Paid plans are billed in advance on the cycle you select and renew automatically unless cancelled. Free trials, cancellation and refunds are described in our Refund Policy, which forms part of these Terms. You authorise us (and our payment processor) to charge your chosen payment method for applicable fees.",
    ],
  },
  {
    h: "8. Intellectual property",
    p: [
      "The Service, including its software, design, branding and content (excluding Your Content), is owned by us or our licensors and is protected by intellectual property laws. These Terms do not transfer any such rights to you.",
    ],
  },
  {
    h: "9. Third-party services",
    p: [
      "The Service may integrate with third-party services (for example, authentication, payments, AI and email providers). Your use of those services may be subject to their own terms, and we are not responsible for third-party services.",
    ],
  },
  {
    h: "10. Availability and warranties",
    p: [
      "We aim to keep the Service available and reliable but do not guarantee it will be uninterrupted or error-free. Except as required by law, the Service is provided \u201cas is\u201d and \u201cas available\u201d without warranties of any kind.",
    ],
  },
  {
    h: "11. Limitation of liability",
    p: [
      "Nothing in these Terms limits liability that cannot be limited by law (such as for death or personal injury caused by negligence, or fraud). Subject to that, we are not liable for loss of profits, revenue, data or goodwill, or for indirect or consequential loss, and our total liability arising out of or in connection with the Service is limited to the amount you paid us in the 12 months before the event giving rise to the claim.",
      "If you are a consumer, you have legal rights that these Terms do not affect.",
    ],
  },
  {
    h: "12. Indemnity",
    p: [
      "You agree to indemnify us against claims, losses and costs arising from Your Content or your breach of these Terms or of applicable law, to the extent permitted by law.",
    ],
  },
  {
    h: "13. Suspension and termination",
    p: [
      "You may stop using the Service and cancel at any time. We may suspend or terminate your access if you materially breach these Terms, fail to pay, or where necessary to protect the Service or other users. On termination, your right to use the Service ends and we will handle your data as described in our Privacy Policy.",
    ],
  },
  {
    h: "14. Changes to these terms",
    p: [
      "We may update these Terms from time to time. We will post the updated version here and, where changes are material, give you reasonable notice. Continued use of the Service after changes take effect means you accept the updated Terms.",
    ],
  },
  {
    h: "15. Governing law and jurisdiction",
    p: [
      "These Terms and any dispute arising out of them are governed by the laws of England and Wales, and the courts of England and Wales have exclusive jurisdiction, except that if you are a consumer resident elsewhere in the UK you may also bring proceedings in your local courts.",
    ],
  },
  {
    h: "16. Contact us",
    p: ["You can contact us about these Terms in writing at our registered office: Flat 6 Logan House, 1 Logan Place, London, United Kingdom, W8 6QN."],
  },
];

export default function TermsConditions() {
  return (
    <LegalLayout
      testid="terms-page"
      title="Terms & Conditions"
      updated="6 August 2026"
      intro="These Terms & Conditions set out the rules for using Swishr Central. Please read them carefully."
      sections={sections}
    />
  );
}
